import React from "react";
import "./AtaObjetivosSkeleton.css";

export default function AtaObjetivosSkeleton() {
  return (
    <div className="ata-section">
      <div className="ata-objectives skeleton-objetivos">

        {/* Header */}
        <div className="objetivos-header">
          <div className="sk sk-title" />
          <div className="sk sk-circle sm" />
        </div>

        {/* Barra de progresso */}
        <div className="progress-segmentada-wrap">
          <div className="progress-segmentada">
            {Array.from({ length: 70 }).map((_, i) => (
              <div key={i} className="sk sk-segment" />
            ))}
          </div>

          <div className="sk sk-percent" />
        </div>

        {/* Lista */}
        <div className="objetivos-scroll">
          {Array.from({ length: 6 }).map((_, index) => (
            <div className="obj-card skeleton-card" key={index}>

              <div className="obj-linha1">
                <div className="sk sk-checkbox" />

                <div className="obj-skeleton-texto">
                  <div
                    className="sk sk-line"
                    style={{
                      width: `${65 + Math.random() * 25}%`,
                    }}
                  />
                </div>

                <div className="obj-icons-skeleton">
                  <div className="sk sk-icon" />
                  <div className="sk sk-icon" />
                  <div className="sk sk-icon" />
                </div>
              </div>

              <div className="obj-linha2">
                <div className="obj-avatars-skeleton">
                  <div className="sk sk-circle" />
                  <div className="sk sk-circle" />
                  <div className="sk sk-circle" />
                </div>

                <div className="obj-actions-skeleton">
                  <div className="sk sk-date" />
                  <div className="sk sk-icon" />
                  <div className="sk sk-icon" />
                  <div className="sk sk-icon" />
                </div>
              </div>

            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="objetivos-footer-filtro">

          <div className="footer-left">
            <div className="sk sk-icon" />

            {Array.from({ length: 7 }).map((_, i) => (
              <div className="sk sk-circle" key={i} />
            ))}
          </div>

          <div className="sk sk-filter" />

        </div>

      </div>
    </div>
  );
}